module.exports = __webpack_public_path__ + "media/honey-icons/icon-mimic-29276f50.svg";